module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_4-db7206dfc70a0ff7196741c5d5de88b0.png";